module.exports = __webpack_public_path__ + "img/cornerRightTop.3555d49e.svg";